<template>
    <div>
        <v-card>
            <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="title">
                    <h1>Penilaian Mata Kuliah</h1>
                </div>
            </div>
            <v-card-title>
                <v-row>
                    <v-col>
                        <b-form>
                            <!-- <span>Prodi</span> -->
                            <!-- <b-form-select style="width: 50%;" id="input-1" v-model="selectedprodi" :options="prodi"
                                class="ml-6"></b-form-select> -->
                            <SelectComponent :data="prodi" :changeSelected="changeProdi" Title="Prodi"
                                :models="request.selectedprodi"></SelectComponent>
                            <!-- {{ this.prodi }} -->
                        </b-form>
                    </v-col>
                    <v-col>
                        <b-form>
                            <!-- <span>Mata Kuliah</span> -->
                            <!-- <b-form-select style="width: 50%;" id="input-1" v-model="selectedmatkul" :options="matkul"
                                class="ml-6"></b-form-select> -->
                            <!-- <selectMatkul :changematkul="changematkul"></selectMatkul> -->
                            <SelectComponent :data="matkul" :changeSelected="changeMatkul" Title="Mata Kuliah"
                                :models="request.selectedmatkul"></SelectComponent>
                        </b-form>
                    </v-col>
                </v-row>
            </v-card-title>
            <b-tabs content-class="mt-3">
                <b-tab title="Input Nilai" :active="(tab1) ? true : false">
                    <v-data-table :headers="code4.headers"
                        :items="(request.selectedprodi && request.selectedmatkul) ? code4.desserts : code4.kosong"
                        :search="code4.search">
                        <template v-slot:item.action="{ item }">
                            <div class="d-flex">
                                <v-btn v-b-modal.modal color="primary" class="mr-2">Input Nilai</v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </b-tab>
                <b-tab title="Perhitungan Nilai" :active="(tab2) ? true : false" :disabled="(dis) ? true : false">
                    <b-button variant="info">Generate Nilai</b-button>
                    <v-data-table :headers="code4.headers" :items="code4.desserts" :search="code4.search">
                        <template v-slot:item.action="{ item }">
                            <div class="d-flex">
                                <v-btn v-b-modal.modal @click="modal = true" color="primary" class="mr-2">Input
                                    Nilai</v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </b-tab>
            </b-tabs>
        </v-card>

        <b-modal size="lg" hide-footer id="modal" title="" v-model="modal">
            <h4>Tambah Data Nilai</h4>
            <b-table responsive :fields="code4.headers" :items="code4.desserts">
                <template #cell(uts)="data">
                    <input type="text" :value="data.value" />
                </template>
            </b-table>
            <b-button type="submit" variant="primary" class="mt-2" @click="() => { onChangeActive() }">simpan</b-button>
        </b-modal>
    </div>
</template>

<style scoped>
textarea {
    resize: none;
    height: 150px;
}

.colorBlue {
    background-color: #3751E4;
}
</style>

<script>
// import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from 'axios';
// import selectProdi from "@/view/content/components/select/SelectProdi.vue";
// import selectMatkul from '@/view/content/components/select/SelectMataKuliah.vue';
import SelectComponent from '@/view/content/components/select/SelectComponent.vue';

export default {
    data() {
        return {
            code4: {
                search: "",
                headers: [
                    { text: "No", value: "no" },
                    { text: "NRP", value: "nrp" },
                    { text: "Nama", value: "nama" },
                    { text: "Komponen UTS", value: "uts" },
                    { text: "Total", value: "total" },
                    { text: "Aksi", value: "action" }
                ],
                desserts: [
                    {
                        no: 1,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 2,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 3,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 4,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 5,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    }
                ],
                kosong: []
            },
            code5: {
                headers: [
                    { text: "No", value: "no" },
                    { text: "NRP", value: "nrp" },
                    { text: "Nama", value: "nama" },
                    { text: "Komponen UTS", value: "uts" },
                    { text: "Total", value: "total" },
                    { text: "Aksi", value: "action" }
                ],
                desserts: [
                    {
                        no: 1,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 2,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 3,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 4,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    },
                    {
                        no: 5,
                        nrp: "17181",
                        nama: "ADE TOSHIO FADLY SE",
                        uts: "0",
                        total: "00.00"
                    }
                ],
            },
            prodi: [
                { id: null, text: '--Pilih Prodi--' },
            ],
            matkul: [
                { id: null, text: '--Pilih Matkul--' },
            ],
            statusModal: '',
            request: {
                selectedprodi: '',
                selectedmatkul: '',
            },
            tab1: true,
            tab2: false,
            dis: true,
            modal: false
        };
    },
    components: {
        SelectComponent
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Penilaian Siswa" },
            { title: "Master Penilaian" },
        ]);
        this.getprodi();
        this.getmatkul();
        // axios({
        //     method: "GET",
        //     url: `http://dev.maxxima-products.id/siak-api/master/study-programs`,
        //     headers: this.config.headers,
        // }).then(response => {
        //     
        //     this.prodi = response.data
        // });
        // const res = await axios.get(`http://dev.maxxima-products.id/siak-api/master/study-programs`)
        // this.prodi = res.data
    },
    methods: {
        onChangeActive() {
            this.tab1 = false;
            this.tab2 = true;
            this.dis = false;
            this.modal = false;
            // this.$swal(this.tab1, this.tab2, 'OK');
        },
        changeProdi: function (selected) {
            // 
            this.request.selectedprodi = selected;
            
        },
        changeMatkul: function (selected) {
            // 
            this.request.selectedmatkul = selected;
            
        },
        async getprodi() {
            const res = await axios.get(`master/field-of-study`);
            
            res.data.data.map((prod) => {
                
                let obj = { id: prod.key, text: prod.name };
                this.prodi.push(obj);
            })
        },
        async getmatkul() {
            const res = await axios.get(`master/courses`);
            
            res.data.data.map((data) => {
                
                let obj = { id: data.key, text: data.course_name };
                this.matkul.push(obj);
            })
        },
    },
}
</script>